"use client";

// Imported for the side effect: the module patches `history.pushState` and
// starts counting at evaluation time.
import "@/lib/navigation-history";

/**
 * Loads the navigation-history bookkeeping on every route.
 *
 * The counter has to see *every* entry this document creates, and it only sees
 * the ones made after its module is evaluated. Until this existed the module
 * arrived with whichever chunk first imported it — `<BackButton />` or a page's
 * own back handler — so on `/hiives`, which has neither, `history.pushState`
 * was still unpatched and the very first navigation of a session went
 * uncounted. Back then behaved differently on the first hop than on every hop
 * after it, from the same screen, with no way for a reader to tell which they
 * were about to get.
 *
 * Rendered from the root layout rather than the app shell because the shell
 * only wraps the navbar route groups: the hiive, venue and event pages — the
 * three that own their own back handling — sit in `(without-navbar)` and have
 * no shell at all.
 *
 * Renders nothing; it exists so the import lands in the root layout's chunk.
 */
export function NavigationHistoryTracker() {
  return null;
}
